import type { GetRateTableDependencies } from './types/GetRateTableDependencies';
import type { GetRateTableFunction } from './types/GetRateTableFunction';
import type { RateTable } from './types/RateTable';
import { getRateTable } from './getRateTable';

let cachedRateTable: RateTable | null = null;

export const getRateTableCached =
  ({
    baseURL = import.meta.env.VITE_RATE_TABLE_BASE_URL,
    fetcher = fetch,
    reporter,
  }: GetRateTableDependencies): GetRateTableFunction =>
  (path = import.meta.env.VITE_RATE_TABLE_PATH): Promise<RateTable> => {
    if (cachedRateTable) {
      return Promise.resolve(cachedRateTable);
    }

    return getRateTable({ baseURL, fetcher, reporter })(path).then(
      (rateTable: RateTable) => {
        cachedRateTable = rateTable;
        return rateTable;
      },
    );
  };
